import { render, staticRenderFns } from "./dishonesty-list.vue?vue&type=template&id=226db0bc&scoped=true&"
import script from "./dishonesty-list.vue?vue&type=script&lang=js&"
export * from "./dishonesty-list.vue?vue&type=script&lang=js&"
import style0 from "./dishonesty-list.vue?vue&type=style&index=0&id=226db0bc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226db0bc",
  null
  
)

export default component.exports